import "../phaser.min.js";
import Common from "../Includes/Common.js";

class Question extends Phaser.Scene {

    constructor() {
        super('Question');
        this.common = new Common();
    }

    init(data) {
        this.key = data.key;
        this.question = data.question;
        this.answerLabels = data.answers;
        this.correctAnswer = data.correctAnswer;
        this.callback = data.callback;
        this.startTime = new Date();
        this.finishTime = null;
        this.streakChance = data.streakChance;
        this.quiz = data.quiz;
    }

    resetIt(data) {
        this.key = data.key;
        this.question = data.question;
        this.answerLabels = data.answers;
        this.correctAnswer = data.correctAnswer;
        this.callback = data.callback;
        this.startTime = new Date();
        this.finishTime = null;
        this.streakChance = data.streakChance;
    }

    preload() {}

    create() {
        this.uiContainer = this.add.container(0, 0);
        this.uiContainer.setAlpha(0);

        this.questionBox = this.add.sprite(
                this.scale.width / 2,
                this.scale.height / 12 * 8.5 - 8 * this.common.gameScale,
                'ui',
                'inverse-box'
        )
                .setOrigin(0.5, 1)
                .setScale(4);

        this.questionText = this.add.text(
                this.questionBox.x - (this.questionBox.width * 4 / 2) + (16 * 4),
                this.questionBox.y - (this.questionBox.height * 2) - (12 * 4),
                '',
                {
                    fontFamily: this.common.font,
                    fontSize: 36,
                    color: '#FFFFFF',
                    weight: 'light',
                    wordWrap: {
                        width: this.questionBox.width * 4 - (16 * 4 * 2),
                        useAdvancedWrap: true
                    }
                }
        ).setOrigin(0, 0);

        this.uiContainer.add(this.questionBox);
        this.uiContainer.add(this.questionText);

        const answerBoxWidth = 171 * this.common.gameScale;
        const answerBoxHeight = 36 * this.common.gameScale;
        const margin = 2 * this.common.gameScale;

        const questionPos = [
            {
                x: this.scale.width / 2 - answerBoxWidth / 2 - margin,
                y: this.scale.height / 12 * 8.25 + answerBoxHeight / 2,
                originX: 0.5,
                originY: 0.5
            },
            {
                x: this.scale.width / 2 + answerBoxWidth / 2 + margin,
                y: this.scale.height / 12 * 8.25 + answerBoxHeight / 2,
                originX: 0.5,
                originY: 0.5
            },
            {
                x: this.scale.width / 2 - answerBoxWidth / 2 - margin,
                y: this.scale.height / 12 * 8.25 + answerBoxHeight * 1.5 + margin,
                originX: 0.5,
                originY: 0.5
            },
            {
                x: this.scale.width / 2 + answerBoxWidth / 2 + margin,
                y: this.scale.height / 12 * 8.25 + answerBoxHeight * 1.5 + margin,
                originX: 0.5,
                originY: 0.5
            }
        ];

        this.answerContainers = [];

        // Always create 4 answer slots
        for (let i = 0; i < 4; i++) {

            const { x, y, originX, originY } = questionPos[i];

            const answerContainer = this.add.container(x, y);

            const answerBox = this.add.sprite(
                    0,
                    0,
                    'ui',
                    'triviaboxsmall'
            )
                    .setOrigin(originX, originY)
                    .setScale(this.common.gameScale);

            const answerText = this.add.text(
                    0,
                    -4,
                    '',
                    {
                        fontFamily: this.common.font,
                        fontSize: 36,
                        color: '#333',
                        align: 'center',
                        wordWrap: {
                            width: answerBox.width * 4 - (16 * 4 * 2),
                            useAdvancedWrap: true
                        }
                    }
            ).setOrigin(originX, originY);

            answerContainer.add([answerBox, answerText]);

            this.answerContainers.push({
                container: answerContainer,
                box: answerBox,
                text: answerText
            });

            this.uiContainer.add(answerContainer);
        }

        this.updateQuestionUI();

        this.fadeInUI();

        this.events.on('question-answered', () => {

            this.fadeOutUI(() => {
                this.events.emit('ready-for-next-question');
            });

        }, this);

        const quiz = this.scene.get('Quiz');

        quiz.events.on('resetQuestion', this.onResetQuestion, this);

        // this.events.once('shutdown', () => {
        //     quiz.events.off('resetQuestion', this.onResetQuestion, this);
        // });
    }

    onResetQuestion = (data) => {
        this.resetIt(data);
        this.updateQuestionUI();
        this.fadeInUI();
    };

    fadeInUI() {
        this.uiContainer.setAlpha(0);

        this.tweens.add({
            targets: this.uiContainer,
            alpha: 1,
            duration: 600,
            ease: 'Power1',
            delay: 1000,
            onComplete: () => {
                const quiz = this.scene.get('Quiz');
                quiz.events.emit('start-timer');
            }
        });
    }

    fadeOutUI(callback) {
        this.tweens.add({
            targets: this.uiContainer,
            alpha: 0,
            duration: 400,
            ease: 'Power1',
            delay: 600,
            onComplete: callback
        });
    }

    updateQuestionUI() {
        this.questionText.setText(this.question);

        for (let i = 0; i < this.answerContainers.length; i++) {

            const answerUI = this.answerContainers[i];

            if (i < this.answerLabels.length) {

                answerUI.container.setVisible(true);

                answerUI.box
                        .setTexture('ui', 'triviaboxsmall')
                        .setScale(this.common.gameScale);

                answerUI.text.setText(this.answerLabels[i]);

            } else {

                answerUI.container.setVisible(false);
            }
        }
        this.setupAnswerHandlers();
        this.startTime = new Date();
    }

    setupAnswerHandlers() {
        this.answerContainers.forEach((answerUI, index) => {
            const answerBox = answerUI.box;
            answerBox.removeAllListeners();
            if (index >= this.answerLabels.length) {
                return;
            }

            answerBox.setInteractive({
                cursor: 'pointer'
            });

            answerBox.on('pointerover', () => {
                answerBox.setTexture('ui', 'boxsmall-hover');
                this.tweens.add({
                    targets: answerBox,
                    scale: this.common.gameScale * 1.04,
                    duration: 100
                });
            });

            answerBox.on('pointerout', () => {
                answerBox.setTexture('ui', 'triviaboxsmall');
                this.tweens.add({
                    targets: answerBox,
                    scale: this.common.gameScale,
                    duration: 100
                });
            });

            answerBox.on('pointerdown', () => {
                const isRightAnswer = this.correctAnswer === index;
                this.finishTime = new Date();
                this.elapsedTime = this.finishTime - this.startTime;
                if (isRightAnswer) {
                    answerBox.setTexture('ui', 'box-small-correct');
                } else {
                    answerBox.setTexture('ui', 'box-small-wrong');
                    const correctBox = this.answerContainers[this.correctAnswer]?.box;
                    if (correctBox) {
                        correctBox.setTexture(
                                'ui',
                                'box-small-correct'
                        );
                    }
                }
                this.events.emit('question-answered', {
                    key: this.key,
                    elapsedTime: this.elapsedTime,
                    isRightAnswer: isRightAnswer,
                    answered: index
                });
                const quiz = this.scene.get('Quiz');
                quiz.events.emit('stop-timer');
                this.answerContainers.forEach(answer => {
                    answer.box.removeAllListeners();
                });

            });

        });

    }

}

export default Question;